import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'

const TWEAK_DEFAULTS = {
  accent: '#1B7B3F',
  density: 'comfortable',
  gridOverlay: false,
  uppercaseDisplay: false,
}

export const AppContext = createContext(null)

export function AppProvider({ children }) {
  const [tweaks, setValues] = useState(TWEAK_DEFAULTS)

  const setTweak = useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null
      ? keyOrEdits
      : { [keyOrEdits]: val }
    setValues((prev) => ({ ...prev, ...edits }))
    window.parent.postMessage({ type: '__edit_mode_set_keys', edits }, '*')
    window.dispatchEvent(new CustomEvent('tweakchange', { detail: edits }))
  }, [])

  useEffect(() => {
    document.documentElement.style.setProperty('--accent', tweaks.accent)
    document.documentElement.style.setProperty('--accent-soft', tweaks.accent + '20')
  }, [tweaks.accent])

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--density-pad',
      tweaks.density === 'compact' ? '0.85' : '1'
    )
  }, [tweaks.density])

  return (
    <AppContext.Provider value={{ tweaks, setTweak }}>
      {children}
    </AppContext.Provider>
  )
}

export function useTweaks() {
  const ctx = useContext(AppContext)
  if (!ctx) throw new Error('useTweaks must be used within AppProvider')
  return [ctx.tweaks, ctx.setTweak]
}
